import { Unit } from '../components/ServiceItem';

export type UnitAppointment = {
  unitId: string;
  name: string;
  address: string;
  additionalInfo: string;
  neighborhood: string;
  number: string;
  city: string;
  state: string;
  catalogUnitId: string;
};

export const createUnitAppointment = (branch: Unit) => {
  const unit = {} as UnitAppointment;
  unit.unitId = branch.id_sgh;
  unit.catalogUnitId = branch.id;
  unit.name = branch.name;
  unit.address = branch.address;
  unit.neighborhood = branch.neighborhood;
  unit.number = branch.address_number;
  unit.city = branch.city;
  unit.state = branch.state;
  unit.additionalInfo = branch.address_complement;
  return unit;
};
